import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkIsOutskirtBuildingLibrary } from "./checkIsOutskirtBuildingLibrary";
import { pathSelectImprovementTabInMarketMenu } from "./paths/pathSelectImprovementTabInMarketMenu";
import { pathSelectMainTabInLibraryMenu } from "./paths/pathSelectMainTabInLibraryMenu";
export var epicShowMeBuyImprovement = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShowMe.QuestTaskBuyImprovement), guard(state$, deps, pathSelectImprovementTabInMarketMenu)([
        checkIsOutskirtBuildingLibrary(pathSelectMainTabInLibraryMenu),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/buy-improvement/epicShowMeBuyImprovement.ts
// module id = 2351
// module chunks = 3